import request from '@/utils/request';

export default{
    //获取未审核的维修单
    getCheckRepair(opt) {
      const params = {
        ...opt
      }
      return request.get('/checking/queryCheckingGuarantees/'  + opt.page + '/' + opt.size, {
        params: params
      });
    },
    //审核维修单
    checkRepair(opt) {
      const params = {
        ...opt
      }
      return request.get('/checking/checkingGuarantees', {
        params: params
      });
    },
    //派工维修
    dispatchMaintenance(opt) {
      const params = {
        ...opt
      }
      return request.get('/checking/dispatchMaintenance', {
        params: params
      });
    },
    //新增故障类型
    addFaultType(opt) {
      const params = {
        ...opt
      }
      return request.get('/guarantee/insertFaultType', {
        params: params
      });
    },
    //查询故障类型
    getFaultType(opt) {
      const params = {
        ...opt
      }
      return request.get('/guarantee/queryFaultType/'  + opt.page + '/' + opt.size, {
        params: params
      });
    },
    //删除故障类型
    deleteFaultType(opt) {
      const params = {
        ...opt
      }
      return request.get('/guarantee/deleteFaultType', {
        params: params
      });
    },
    //查询用户评价
    getProgress(opt) {
      const params = {
        ...opt
      }
      return request.get('/evaluate/queryEvaluate', {
        params: params
      });
    },
}